import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { viewDealsList, updateDeal } from "../../Redux/Actions/dealsAction";
import { columnsDealsList } from "../../Global Functions/columnsAntd";
import DateRangePopup from "../../Utils/dateFilterPopup";
import TableComponentCp from "../../Global Functions/tableComponentsCp";

const ListDeals = () => {

  const [searchQuery, setSearchQuery] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const dispatch = useDispatch();

  const fetchDetails = useCallback((page, limit) => {
    const dealsPayload = {
      page,
      limit,
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };
    dispatch(viewDealsList(dealsPayload));
  }, [dateRange.end, dateRange.start, debouncedSearch, dispatch]);


  const { deals, loading } = useSelector((state) => state.deals || {});

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize, fetchDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    if (deals?.total) {
      setPagination((prevData) => ({ ...prevData, total: deals.total }));
    }
  }, [deals]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleStatusChange = async (record, newStatus) => {
    const payload = {
      id: record._id,
      status: newStatus,
    };
    await dispatch(updateDeal(payload));
  };

  const handleFilter = () => {
    // Reset to first page on filter
    setPagination((prevData) => ({ ...prevData, current: 1 }));
    // fetchDetails(1, pagination.pageSize);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <TableComponentCp
        pagination={pagination}
        filterFunction={handleFilter}
        dataSource={Array.isArray(deals?.data) ? deals.data : []}
        onChange={handleTableChange}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        h3heading="Deals List"
        setState={setSearchQuery}
        buttonhead2="Add Deals"
        navigateTo2="/deals/add"
        loading={loading}
        columns={columnsDealsList(handleStatusChange)}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListDeals;
